import { parseCookies, setCookie } from 'nookies'
import get from 'lodash/get'
import startsWith from 'lodash/startsWith'
import i18n from '../../i18n'

const baseUrl = process.env.REACT_APP_BASE_URL

let isRefreshing = false
let refreshPromise = null

/**
 * Refreshes the access token using the refresh token
 * @returns {Promise<boolean>} Returns true if refresh was successful, false otherwise
 */
const refreshToken = async () => {
  if (isRefreshing && refreshPromise) {
    return refreshPromise
  }

  isRefreshing = true
  refreshPromise = (async () => {
    try {
      const { refreshToken: refreshTokenCookie } = parseCookies()

      if (!refreshTokenCookie) {
        return false
      }

      const authToken = startsWith(refreshTokenCookie, 'Bearer ') ? refreshTokenCookie : `Bearer ${refreshTokenCookie}`

      const config = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Accept-Language': i18n.language || 'en',
          Authorization: authToken,
        },
      }

      const response = await fetch(`${baseUrl}/user/refresh-token`, config)
      const data = await response.json()

      if (data.success && data.data) {
        const config = {
          path: '/',
          maxAge: 604800,
          sameSite: true,
          secure: true,
        }

        const at = `Bearer ${get(data.data, 'accessToken', '')}`
        setCookie(null, 'accessToken', at, config)
        setCookie(null, 'refreshToken', get(data.data, 'refreshToken', ''), config)

        return true
      }

      return false
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error refreshing token:', error)
      return false
    } finally {
      isRefreshing = false
      refreshPromise = null
    }
  })()

  return refreshPromise
}

export default refreshToken
